var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.208,
    height: 26,
    viewBox: "0 0 22.208 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1792",
    "data-name": "Group 1792",
    transform: "translate(-37.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1789",
    "data-name": "Group 1789",
    transform: "translate(48.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1788",
    "data-name": "Group 1788",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M252.419,0a5.632,5.632,0,0,0-3.647,1.974,4.892,4.892,0,0,0-1.194,3.8,4.754,4.754,0,0,0,3.68-1.88A5.281,5.281,0,0,0,252.419,0Z",
    transform: "translate(-247.522)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1791",
    "data-name": "Group 1791",
    transform: "translate(37.336 5.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1790",
    "data-name": "Group 1790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M58.792,122.539a6.537,6.537,0,0,0-4.968-2.7c-2.332,0-3.318,1.143-4.938,1.143-1.67,0-2.94-1.139-4.956-1.139A6.72,6.72,0,0,0,38.5,123.2c-1.88,2.984-1.558,8.593,1.488,13.372,1.09,1.71,2.546,3.632,4.451,3.649,1.695.017,2.173-1.113,4.469-1.124s2.732,1.139,4.423,1.121c1.906-.015,3.442-2.145,4.532-3.855a19.328,19.328,0,0,0,1.679-3.226A5.925,5.925,0,0,1,58.792,122.539Z",
    transform: "translate(-37.336 -119.84)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardApple);
export default __webpack_public_path__ + "static/media/dashboardApple.5bbca579055231a7d0047601294aa008.svg";
export { ForwardRef as ReactComponent };